/* eslint-disable no-console */
import React, { useEffect, useLayoutEffect, useState } from 'react'

import axios from 'axios'
import bestContentJSON from 'src/assets/data/best-content.json'
import homeMidia from 'src/assets/data/home-midia.json'
import lastContentJSON from 'src/assets/data/last-content.json'
import spotLightJSON from 'src/assets/data/spotlight-articles.json'
import BestContents from 'src/components/BestContents'
import CalendarEvents from 'src/components/CalendarEvents'
import CarouselTimerMobile from 'src/components/CarouselTimer/CarouselTimerMobile'
import CategoryHeader from 'src/components/CategoryHeader'
import HeroNews from 'src/components/HeroNews'
import HomeMidia from 'src/components/HomeMidia'
import Layout from 'src/components/Layout'
import Newsletter from 'src/components/Newsletter'
import SEO from 'src/components/Seo'
import SpotlightNewsSmall from 'src/components/SpotlightNewsSmall'
import useWidth from 'src/hooks/useWidth'
import {
  returnAllArticlesOrderPublishDate,
  SpotlightNewsSmallField,
} from 'src/services/articles/articles'

import pageContext from './pageContext.json'

interface AnalyticsData {
  uuid: string
}

interface SpotlightNewsSmallItem {
  categoryId?: string
  title: string
  link: string
  image: string
  video: boolean
}

interface SpotlightItem {
  showCategoryLabel: string
  category: {
    icon: string
    id: string
    name: string
    slug: string
    subTitle: string
    template: string
    colors: {
      primary: string
      primary300: string
      primary200: string
      primary100: string
    }
  }
  image: string
  alt: string
  slug: string
  title: string
  subtitle: string
  subTitle: string
  categorySlug: string
  subcategorySlug: string
  segmentSlug: string
  subCategory: string
  isFromInset?: boolean
  insetCategory?: string
  spotlight?: boolean
}

interface BestContentItem {
  id: string
  slug: string
  title: string
  image: string
  publishedAt: string
  video: boolean
  isBestContent: boolean
  subCategory: string
  label: string
  category: string
  link: string
}

interface HomeMidiaData {
  videos?: unknown[]
}

const spotlightData = (spotLightJSON as SpotlightItem[]).filter(
  (item: SpotlightItem) => item.spotlight,
)

const spotlightArticles = {
  showCategoryHeader: false,
  template: 'C',
  dados: spotlightData,
}

const bestContentArticles = {
  showCategoryHeader: false,
  template: 'D',
  dados: bestContentJSON as BestContentItem[],
}

const Home = () => {
  const [isMobile, setIsMobile] = useState(false)
  const [, setMoreRead] = useState([])

  const windowWidth = useWidth(200)
  useLayoutEffect(() => {
    setIsMobile(windowWidth < 768)
  }, [windowWidth])

  useEffect(() => {
    returnArticlesMoreRead()
  })

  async function returnArticlesMoreRead() {
    try {
      const articles = returnAllArticlesOrderPublishDate()
      const response = await axios.post(`${process.env.CMS_API}/news/analyticsdata`)
      const { data } = response
      const AllResponse = data.reduce((all: SpotlightNewsSmallItem[], item: AnalyticsData) => {
        const artigo = articles.find(
          (articleFind: typeof articles[0]) => articleFind.id === item.uuid,
        )
        if (!artigo) {
          return all
        }
        return [...all, SpotlightNewsSmallField(artigo)]
      }, [])
      setMoreRead(AllResponse)
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <Layout pageContext={pageContext} isHome>
      <SEO
        title={pageContext.metaTitle}
        url={process.env.BASE_URL}
        meta={[
          {
            name: 'description',
            content: pageContext.metaDescription,
          },
          {
            property: 'og:title',
            content: pageContext.metaTitle,
          },
          {
            property: 'og:description',
            content: pageContext.metaDescription,
          },
          {
            property: 'og:locale',
            content: 'pt_BR',
          },
          {
            property: 'og:type',
            content: 'website',
          },
          {
            property: 'og:url',
            content: `${process.env.BASE_URL}`,
          },
          {
            property: 'og:site_name',
            content: 'Banco Inter',
          },
          {
            property: 'twitter:site',
            content: '@bancointer',
          },
          {
            property: 'twitter:creator',
            content: '@bancointer',
          },
        ]}
      />
      <section className="py-4">
        <div className="container">
          {!isMobile ? (
            <HeroNews data={spotlightData} />
          ) : (
            <CarouselTimerMobile data={spotlightArticles} />
          )}
        </div>
      </section>
      <Newsletter page="home" />

      <CalendarEvents />
      {(() => {
        const { videos } = homeMidia as HomeMidiaData
        return videos && Array.isArray(videos) && videos.length > 0
      })() && (
        <section>
          <HomeMidia />
        </section>
      )}

      <section className="pt-5 pb-4">
        <div className="container">
          <BestContents bannerFill={bestContentArticles} />
        </div>
      </section>
      <section className="pt-5 pb-4">
        <div className="container">
          <CategoryHeader category="Últimos conteúdos" className="mb-3" />
          <SpotlightNewsSmall data={lastContentJSON} />
        </div>
      </section>
    </Layout>
  )
}

export default Home
